/** @format */

import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as departmentActions from "../../Redux/Actions/department";
import * as masterProcessActions from "../../Redux/Actions/masterProcess";
import * as processActions from "../../Redux/Actions/process";
import { toastMessage } from "../../utils/toast";
import { useSelector, useDispatch } from "react-redux";
import { clearSession } from "../../utils/initiate";
import Warning from "../Ui/400";
import {
  setDepartmentIdFilter,
  setDepartmentNameFilter,
  resetDepartmentFilter,
  setProcessIdFilter,
  setProcessNameFilter,
  resetProcessFilter,
  setMasterProcessIdFilter,
  setMasterProcessNameFilter,
  resetMasterProcessFilter,
} from "../../Redux/Reducers/commonFilters";
import ReactPaginate from "react-paginate";
import { search } from "../../utils";

const MasterManagement = ({ match, history }) => {
  let itemsPerPage = 10;
  const [data, setData] = useState([]);
  const [parmenentData, setParmenentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errStatus, setErrStatus] = useState(200);
  const userData = useSelector(({ User }) => User.data);
  const dispatch = useDispatch();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const { t } = useTranslation();
  const {
    departmentNameFilter,
    departmentIdFilter,
    masterProcessIdFilter,
    masterProcessNameFilter,
    processIdFilter,
    processNameFilter,
  } = useSelector((state) => state.commonFilters);

  let { type: masterType } = match.params;
  let name = masterType.includes("department")
    ? "Department"
    : masterType.includes("master")
    ? "Master Process"
    : "Process";

  useEffect(() => {
    setLoading(true);
    let type = masterType.includes("department")
      ? departmentActions
      : masterType.includes("master")
      ? masterProcessActions
      : masterType.includes("process")
      ? processActions
      : "";
    type !== "" &&
      type
        .getAll()
        .then((res) => {
          if (res && res.data) {
            setData(res.data);
            setParmenentData(res.data);
            handleFilter(res.data);
          } else {
            setData([]);
            setParmenentData([]);
            toastMessage(
              "error",
              (res && res.message) || `Unable to load the ${name}`
            );
          }
          setLoading(false);
        })
        .catch((err) => {
          setErrStatus(err?.response?.status);
          err?.response?.status === 401 && clearSession(dispatch, history);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterType, name, dispatch, history, userData]);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  if (errStatus === 400) {
    return <Warning history={history} />;
  }

  const defineType = (type) => {
    switch (type) {
      case "Process":
        return {
          id: processIdFilter,
          name: processNameFilter,
          reset: resetProcessFilter,
          setId: setProcessIdFilter,
          setName: setProcessNameFilter,
        };
      case "Master Process":
        return {
          id: masterProcessIdFilter,
          name: masterProcessNameFilter,
          reset: resetMasterProcessFilter,
          setId: setMasterProcessIdFilter,
          setName: setMasterProcessNameFilter,
        };
      case "Department":
        return {
          id: departmentIdFilter,
          name: departmentNameFilter,
          reset: resetDepartmentFilter,
          setId: setDepartmentIdFilter,
          setName: setDepartmentNameFilter,
        };
      default:
        return {};
    }
  };

  const handleFilter = (arr) => {
    let temp = null;

    if (
      (departmentNameFilter && departmentIdFilter) ||
      (masterProcessIdFilter && masterProcessNameFilter) ||
      (processIdFilter && processNameFilter)
    ) {
      const filtered = search({
        items: arr,
        searchParams: ["id"],
        filterSearch: defineType(name)["id"],
      });
      temp = search({
        items: filtered,
        searchParams: ["name"],
        filterSearch: defineType(name)["name"],
      });
    } else if (departmentIdFilter || masterProcessIdFilter || processIdFilter) {
      temp = search({
        items: arr,
        searchParams: ["id"],
        filterSearch: defineType(name)["id"],
      });
    } else if (
      departmentNameFilter ||
      masterProcessNameFilter ||
      processNameFilter
    ) {
      temp = search({
        items: arr,
        searchParams: ["name"],
        filterSearch: defineType(name)["name"],
      });
    }

    temp && setData(temp);
  };

  const clearFilter = () => {
    setData(parmenentData);
    dispatch(defineType(name)["reset"]());
  };

  return (
    <>
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="page-title my-2">
            {t(`mastersManagement.${masterType}.title`)}
          </h4>
        </div>
        <div className="row">
          <div className="col-lg-12 col-xxl-12">
            <div className="card card-custom card-stretch gutter-b">
              {loading ? (
                <Loader
                  type="ThreeDots"
                  color="#ad1a5f"
                  height={40}
                  width={40}
                  style={{ textAlign: "center", marginBottom: "50px" }}
                />
              ) : (
                <div className="card-body py-3">
                  <div className="tab-content">
                    <div className="d-flex align-items-center mb-3">
                      <div className="me-3" style={{ width: "20%" }}>
                        <label className="mb-1 ms-1 me-3">
                          {t("filter.id")}
                        </label>
                        <input
                          placeholder={t("filter.idPlaceholder")}
                          type="number"
                          className="form-control me-3"
                          name="Filter ID"
                          value={defineType(name)["id"]}
                          onChange={(e) =>
                            dispatch(
                              defineType(name)["setId"](e.target.value.trim())
                            )
                          }
                        />
                      </div>
                      <div className="me-3" style={{ width: "20%" }}>
                        <label className="mb-1 ms-1 me-3">
                          {t("filter.name")}
                        </label>
                        <input
                          placeholder={t("filter.namePlaceholder")}
                          type="text"
                          className="form-control me-3"
                          name="Filter ID"
                          value={defineType(name)["name"]}
                          onChange={(e) =>
                            dispatch(
                              defineType(name)["setName"](e.target.value.trim())
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <button
                        onClick={() => handleFilter(data)}
                        type="button"
                        className="d-flex px-5 align-items-center btn btn-primary font-weight-bold"
                      >
                        {t("jobsManagement.filters.filter")}
                      </button>
                      <button
                        onClick={clearFilter}
                        type="button"
                        className="px-5 d-flex align-items-center btn btn-primary font-weight-bold mx-2"
                      >
                        {t("jobsManagement.filters.clearFilters")}
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-head-custom table-vertical-center table-head-bg">
                        <thead>
                          <tr className="text-left">
                            <th style={{ minWidth: "60px" }} className="ps-5">
                              <span className="text-dark-75">
                                {t("mastersManagement.manage.id")}
                              </span>
                            </th>
                            <th style={{ minWidth: "80px" }}>
                              <span className="text-dark-75">
                                {t("mastersManagement.manage.name")}
                              </span>
                            </th>
                            {!masterType.includes("department") && (
                              <th style={{ minWidth: "100px" }}>
                                <span className="text-dark-75">
                                  {t("mastersManagement.manage.department")}
                                </span>
                              </th>
                            )}
                            {masterType === "process" && (
                              <th style={{ minWidth: "100px" }}>
                                <span className="text-dark-75">
                                  {t("mastersManagement.manage.masterProcess")}
                                </span>
                              </th>
                            )}
                            {masterType.includes("department") && (
                              <th style={{ minWidth: "100px" }}>
                                <span className="text-dark-75">
                                  {t("mastersManagement.manage.icon")}
                                </span>
                              </th>
                            )}
                            <th style={{ minWidth: "175px" }}>
                              <span className="text-dark-75">
                                {t("mastersManagement.manage.action")}
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map(
                            (
                              { id, name, icon, department, masterProcess },
                              index
                            ) => (
                              <tr key={index}>
                                <td className="ps-5">
                                  <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                    {id}
                                  </span>
                                </td>
                                <td className="pl-0 py-8">
                                  <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">
                                    {name}
                                  </span>
                                </td>
                                {!masterType.includes("department") && (
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {department && department.name}
                                    </span>
                                  </td>
                                )}
                                {masterType === "process" && (
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {masterProcess && masterProcess.name}
                                    </span>
                                  </td>
                                )}
                                {masterType.includes("department") && (
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      <img
                                        src={
                                          icon === null
                                            ? "/Assets/nopreview.png"
                                            : icon
                                        }
                                        style={{
                                          width: "30px",
                                          height: "auto",
                                        }}
                                        alt="Department Icon"
                                      />
                                    </span>
                                  </td>
                                )}
                                <td className="pr-0">
                                  <p
                                    onClick={() =>
                                      history.push(
                                        `/master/info/${masterType}?masterID=${id}`
                                      )
                                    }
                                    className="btn btn-warning font-weight-bolder font-size-sm me-2"
                                  >
                                    {t("mastersManagement.manage.more")}
                                  </p>
                                  <p
                                    onClick={() =>
                                      history.push(
                                        `/master/update/${masterType}?masterID=${id}`
                                      )
                                    }
                                    className="btn btn-info font-weight-bolder font-size-sm"
                                  >
                                    {t("mastersManagement.manage.update")}
                                  </p>
                                  {/* <p className="btn btn-danger font-weight-bolder font-size-sm">Remove</p> */}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                      {pageCount > 1 && (
                        <ReactPaginate
                          breakLabel="..."
                          nextLabel=">"
                          previousLabel="<"
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={5}
                          pageCount={pageCount}
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          containerClassName="pagination"
                          activeClassName="active"
                          renderOnZeroPageCount={null}
                        />
                      )}
                      {data.length === 0 && (
                        <p className="text-center mt-5 mb-5">
                          {t("mastersManagement.noDataAvailable")}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterManagement;
